import { Alert, Button, Tag } from 'antd'
import { CheckOutlined, FileTextOutlined } from '@ant-design/icons'
import { Link, useNavigate } from 'react-router-dom'
import { getFeatureTheme } from '@/lib/productBranding'
import { AUTH_PRIMARY_BUTTON_CLASS } from '../../constants'
import { useSignup } from '../SignupContext'

const CAPABILITIES = [
  'Ready in 4 steps: Agenda → Data → AI Analysis → Outputs',
  'Consolidated Analysis across groups',
  'Xero daily refresh (read-only)',
  'In-app assistant (Preppy)',
  'Video Avatar Summaries',
  'Branded exports (PDF, PPT, email)',
]

export default function AdvicePrepProductStep() {
  const navigate = useNavigate()
  const { setStep, setError, loading } = useSignup()
  const theme = getFeatureTheme('advisoryIntel')

  const handleNext = () => {
    setError(null)
    setStep('info')
  }

  return (
    <>
      <div
        className="mb-[1rem] rounded-[0.75rem] border p-[1.25rem]"
        style={{ borderColor: theme.primary, background: theme.surface }}
      >
        <div className="flex items-center gap-[0.875rem]">
          <div
            className="grid h-[3rem] w-[3rem] shrink-0 place-items-center rounded-[0.75rem] text-[1.375rem] text-white"
            style={{ background: theme.primary }}
          >
            <FileTextOutlined />
          </div>
          <div className="min-w-0">
            <div className="font-display text-[1.125rem] font-bold text-gray-900">AdvicePrep</div>
            <div className="text-[0.8125rem] text-gray-600">Advisory AI Meeting Prep</div>
          </div>
          <Tag
            className="ml-auto rounded-full border-none px-[0.625rem] py-[0.125rem] text-[0.71875rem] font-semibold"
            style={{ background: theme.tagBackground, color: theme.tagText }}
          >
            Selected
          </Tag>
        </div>

        <p className="mt-[0.75rem] text-[0.84375rem] leading-[1.55] text-gray-700">
          AdvicePrep pulls your client&apos;s live Xero data, runs AI analysis, and hands you a client-ready meeting
          pack in minutes.
        </p>

        <ul className="mt-[0.875rem] grid list-none grid-cols-1 gap-x-[1.25rem] gap-y-[0.5rem] p-0 sm:grid-cols-2">
          {CAPABILITIES.map((capability) => (
            <li key={capability} className="flex items-start gap-[0.375rem] text-[0.78125rem] text-gray-700">
              <CheckOutlined className="mt-[0.1875rem] shrink-0 text-[0.75rem]" style={{ color: theme.strong }} />
              <span>{capability}</span>
            </li>
          ))}
        </ul>
      </div>

      <Alert
        type="info"
        showIcon
        className="mb-3"
        message="Already a Dashboard Insights customer?"
        description={
          <>
            Don&apos;t sign up again —{' '}
            <Link to="/login" className="font-medium text-brand-600 underline hover:text-brand-700">
              log in to your existing account
            </Link>{' '}
            and add AdvicePrep from there. It goes onto your current subscription and billing, and your
            login stays the same.
          </>
        }
      />

      <div className="signup-step-actions">
        <Button onClick={() => navigate('/login')} disabled={loading}>
          Cancel
        </Button>
        <Button type="primary" loading={loading} disabled={loading} className={AUTH_PRIMARY_BUTTON_CLASS} onClick={handleNext}>
          Next
        </Button>
      </div>
    </>
  )
}
